var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoforward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 21,
    viewBox: "0 0 29 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3103 18.2225C16.3103 19.9971 18.4496 20.8927 19.7138 19.6474L27.5536 11.9248C28.3489 11.1414 28.3489 9.85859 27.5536 9.07518L19.7138 1.35265C18.4496 0.107328 16.3103 1.00291 16.3103 2.77747V5.375C16.3103 6.47957 15.4149 7.375 14.3103 7.375H2C0.89543 7.375 0 8.27043 0 9.375V11.625C0 12.7296 0.89543 13.625 2 13.625H14.3103C15.4149 13.625 16.3103 14.5204 16.3103 15.625V18.2225Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoforward);
export default __webpack_public_path__ + "static/media/goforward.271948f04e385b7d9a1cfac7549e9014.svg";
export { ForwardRef as ReactComponent };